/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';
import AssignUsersForm from './AssignUsersForm/AssignUsersForm';
import AssignUsersSuccess from './AssignUsersSuccess/AssignUsersSuccess';
import AssignUsersError from './AssignUsersError/AssignUsersError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  location: Object,
  accountId: string,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class AssignUsers extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, location, accountStore }: TypeProps = this.props;

    const fields: Array<Object> = [
      {
        name: 'assignUsers',
        label: t('general:actions.assign_location_to'),
        fields: [
          {
            name: 'users',
            label: t('general:user_plural'),
            rules: 'required|array',
            value: [],
            placeholder: t('general:placeholders.first_last_name'),
          },
        ],
      },
    ];

    const hooks: Object = {
      onInit(data: Object) {
        location.hierarchy || accountStore.loadLocationDetails(location.id);
      },
      onSuccess(data: Object) {
        const { users }: Object = data.values().assignUsers;

        actionDrawerStore.assignLocationToUsers(location.id, {
          user_ids: users.join(),
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'assignLocationToUsers',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore, location, accountId }: TypeProps = this.props;

    const title: string = t('general:actions.assign_location_to_users');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <AssignUsersError location={location} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <AssignUsersSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <AssignUsersForm location={location} accountId={accountId} form={this.createForm()} />
      </div>
    );
  }
}
